import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from '../base-api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-user-position',
  templateUrl: './user-position.component.html',
  styleUrls: ['./user-position.component.css']
})
export class UserPositionComponent implements OnInit {
  selectedCategory: string;
  constructor(private router: Router, private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
  }
  uploadMaster() {
    this.router.navigate(['/uploadMaster']);
  }
  dashboard() {
    this.router.navigate(['/dashboard']);
  }
  notification() {
    this.router.navigate(['/notification']);
  }
  viewMaster(){
    this.router.navigate(['/viewMaster']);
  }
  category = [
    { index: '1', viewValue: 'Add User Position' },
    { index: '2', viewValue: 'View User Position' }

  ];
  listClick(event: any, newValue) {
    event.preventDefault();
    
    this.selectedCategory = newValue;

    if (this.selectedCategory == this.category[0].viewValue) {
     
    }
    else if (this.selectedCategory == this.category[1].viewValue) {
     
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/user-position/user-position.component.ts